<template>
  <div class="project clean-sound">
    <project-header :project="project"></project-header>

    <div class="project-gallery row">
      <div class="col-12 project-gallery__img" v-for="image in firstSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/clean-sound/${image}`">
      </div>
      <div class="col-12 clean-sound__outlines">
        <video class="project-gallery__fullsize-video " muted loop playsinline>
          <source src="/static/videos/clean-sound/clean-sound-prod-illu-gif.mp4">
        </video>
      </div>
      <div class="col-12 project-gallery__img" v-for="image in secondSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/clean-sound/${image}`">
      </div>
      <div class="col-12 clean-sound__stack">
        <video class="project-gallery__fullsize-video" muted loop playsinline>
          <source src="/static/videos/clean-sound/poster-stack-1.mp4">
        </video>
      </div>
      <!--<div class="project-gallery__gifs">
        <video class="col-12 col-5-md project-gallery__fullsize-video" playsinline muted loop>
          <source src="/static/videos/clean-sound/reel-outline-60.mp4">
        </video> 
        <video class="col-12 col-5-md project-gallery__fullsize-video" playsinline muted loop>
          <source src="/static/videos/clean-sound/clean-sound-tape.mp4">
        </video> 
      </div>-->
      <div class="col-12 project-gallery__img" v-for="image in thirdSection" :key="image">
        <img class="project-gallery__image" :src="`/static/images/clean-sound/${image}`">
      </div>
      <div class="col-12">
        <video class="project-gallery__fullsize-video" muted loop playsinline>
          <source src="/static/videos/clean-sound/palm-vinyl-brush.mp4">
        </video>
      </div>
      
    </div>

    <project-footer prev="/work/incubes" next="/work/get-clean"></project-footer>
  </div>
</template>

<script>
import project from '../../mixins/project'
import automaticallyPlayVideo from '../../mixins/automaticallyPlayVideo'
import projects from '../../projects'

export default {
  name: 'clean-sound',
  data () {
    return {
      firstSection: [
        'family-1.jpg',
        'logo-bw.jpg',
        'typography.jpg',
        'tagline.jpg',
        'family-packaging-2.jpg',
        'wooden-box-closeup.jpg',
        'record-cleaner-box-set-cropped.jpg',
        'record-cleaner-action-1.jpg',
        'counter-displays.jpg',
        'floor-display-1.jpg'
      ],
      secondSection: [
        'clean-sound-poster-1.jpg',
        'clean-sound-poster-3.jpg'
      ],
      thirdSection: [
        'subpages-clean-sound.jpg',
        'product-subpage-mob.jpg'
      ],
      project: projects.find(project => project.title === 'Clean Sound')
    }
  },
  mixins: [
    project,
    automaticallyPlayVideo
  ]
}
</script>

<style lang="sass">

@import "../../assets/sass/utilities/variables"
@import "../../assets/sass/utilities/mixins"

.clean-sound
  .project-gallery__gifs
    display: flex
    justify-content: center
    flex-direction: column
    margin: 0 12px
    +medium
      flex-direction: row
    video
      margin-top: 0
      height: 100%
      background-color: rgb(26,26,26)

.clean-sound__outlines, .clean-sound__stack
  margin-bottom: 24px

</style>



// WEBPACK FOOTER //
// CleanSound.vue?94459fc0